import { render, staticRenderFns } from "./AddComponentModal.vue?vue&type=template&id=f6cf4af2"
import script from "./AddComponentModal.vue?vue&type=script&lang=js"
export * from "./AddComponentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports